/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductOwnerThemeDto } from './ProductOwnerThemeDto';
import {
    ProductOwnerThemeDtoFromJSON,
    ProductOwnerThemeDtoFromJSONTyped,
    ProductOwnerThemeDtoToJSON,
    ProductOwnerThemeDtoToJSONTyped,
} from './ProductOwnerThemeDto';

/**
 * Product owner information
 * @export
 * @interface ProductOwnerDto
 */
export interface ProductOwnerDto {
    /**
     * Unique identifier of the owner
     * @type {string}
     * @memberof ProductOwnerDto
     */
    id?: string;
    /**
     * Owner name
     * @type {string}
     * @memberof ProductOwnerDto
     */
    name?: string | null;
    /**
     * URL of the owner logo
     * @type {string}
     * @memberof ProductOwnerDto
     */
    logoUrl?: string | null;
    /**
     * 
     * @type {ProductOwnerThemeDto}
     * @memberof ProductOwnerDto
     */
    theme?: ProductOwnerThemeDto;
}

/**
 * Check if a given object implements the ProductOwnerDto interface.
 */
export function instanceOfProductOwnerDto(value: object): value is ProductOwnerDto {
    return true;
}

export function ProductOwnerDtoFromJSON(json: any): ProductOwnerDto {
    return ProductOwnerDtoFromJSONTyped(json, false);
}

export function ProductOwnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductOwnerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'theme': json['theme'] == null ? undefined : ProductOwnerThemeDtoFromJSON(json['theme']),
    };
}

export function ProductOwnerDtoToJSON(json: any): ProductOwnerDto {
    return ProductOwnerDtoToJSONTyped(json, false);
}

export function ProductOwnerDtoToJSONTyped(value?: ProductOwnerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'logoUrl': value['logoUrl'],
        'theme': ProductOwnerThemeDtoToJSON(value['theme']),
    };
}

